import React, { Component } from "react";
import Layout from "../../components/Layout";
import DataEntryTemplate from "../../core/templates/DataEntryTemplate";
import { graphql, navigate } from "gatsby";
import mergeSchema from "../../data/forms/corporate/quoteForm/mergeSchema";
import mergeUiSchema from "../../data/forms/corporate/quoteForm/mergeUiSchema";
import { updateCorporateQuoteFormData } from "../../state/actions/corporate/quoteData";
import { connect } from "react-redux";
import { flows } from "../../../config/app.config";
import FormSideBanner from "../../components/FormSideBanner";
import corporateCalculateConsumptionValues from "../../helpers/corporate/calculateConsumptionValues";
import {
  updateSchemaWithCurrentProduct,
  updateSchemaWithCurrentSupplier
} from "../../helpers/formSchemaUpdates/formSchemaUpdates";
import { saveToCrm } from "../../helpers/kongApi";
import LoaderLogo from "../../components/LoaderLogo";
import { sendEmail } from "../../helpers/kongApiCommon";
import {
  updateCorporateOfferCode,
  updateCorporateOfferId
} from "../../state/actions/corporate/selectedQuote";
import { fetchGoogleClientId } from "../../core/helpers/GoogleAnalytics";
import {subscribeToManyLists} from "../../helpers/mailSubscription/mailSubscription";

export class Form extends Component {
  clearCustomFieldActiveHelpText = () => {
    this.setState({ customFieldActiveHelpText: "" });
  };

  setIsFetching = fetching => {
    this.setState({
      isFetching: fetching
    });
  };

  constructor(props) {
    super(props);

    let schema = updateSchemaWithCurrentSupplier(
      this.props.data.products.edges,
      mergeSchema(this.props.data.formContext.jsonSchema.fields),
      this.props.formData.invoiceType
    );
    schema = updateSchemaWithCurrentProduct(
      this.props.formData.currentSupplier,
      this.props.data.products.edges,
      schema,
      this.props.formData.invoiceType
    );
    this.state = {
      isFetching: false,
      schema,
      initializeOptins: true,
      customFieldActiveHelpText: "",
      customFieldActiveHelpTextRecalculate: false
    };
  }

  render = () => {
    const context = this.props.data.formContext.jsonSchema;
    const uiSchema = mergeUiSchema(context.fields);
    const { isFetching } = this.state;
    return (
      <Layout>
        <DataEntryTemplate
          schema={this.state.schema}
          uiSchema={uiSchema}
          formContent={context}
          formData={this.props.formData}
          onSubmit={() => {
            this.onFormSubmit(this.props.formData);
          }}
          onChange={this.onQuoteFormDataChange}
          breadcrumbCurrentStep={"form"}
          pageTitle={context.pageTitle}
          canonicalUrl={context.canonical}
          defaultFields={this.props.data.defaultFieldContext.jsonSchema}
          breadcrumbStepList={flows.corporatePricing}
          formSideBanner={<FormSideBanner language="gr" />}
          customFieldActiveHelpText={this.state.customFieldActiveHelpText}
          clearCustomFieldActiveHelpText={this.clearCustomFieldActiveHelpText}
          customFieldActiveHelpTextRecalculate={
            this.state.customFieldActiveHelpTextRecalculate
          }
        />
        <LoaderLogo showLoader={isFetching} />
      </Layout>
    );
  };

  onFormSubmit = async formData => {
    if (formData.subscription) {
      subscribeToManyLists(
          formData.email,
          this.props.data.formContext.jsonSchema.mailingLists,
          this.props.auth,
          this.props.location.host,
          this.props.data.strapiComponents.jsonSchema.mailingSource,
          formData,
          {
            email: formData.email
          }
      );
    }

    if (
      formData.invoiceType === "g21" ||
      formData.invoiceType === "g23" ||
      (formData.invoiceType === "g22" &&
        formData.knowledgeOfConsumptionForLead === true)
    ) {
      this.pricingInvoiceSubmit();
    } else {
      const response = await this.leadInvoiceSubmit(formData);
      if (response && response.status === 200) {
        this.props.setCorporateOfferCode(response.data.offerCode);
        this.props.updateCorporateOfferId(response.data.offerId);
        this.sendEmail(
          this.props.formData.email || "",
          (response.data && response.data.offerCode) || "",
          (response.data && response.data.offerId) || ""
        );
        navigate("/corporate/completeLead");
      }
    }
  };

  pricingInvoiceSubmit = () => {
    navigate("/corporate/results");
  };

  leadInvoiceSubmit = async formData => {
    this.setIsFetching(true);
    const response = await this.saveOffer(formData);
    this.setIsFetching(false);
    return response;
  };

  async saveOffer(formData) {
    let response;
    try {
      response = await saveToCrm(
        {
          firstName: formData.customerFirstName || "",
          lastName: formData.customerLastName || "",
          mobilePhone: formData.customerMobilePhoneNumber || "",
          companyName: formData.corporateName || "",
          invoiceType: formData.invoiceType || "",
          email: formData.email || "",
          customerType: "corporate",
          termsAndPoliciesAgreement:
            formData.termsAndPoliciesAgreement || false,
          checkoutType: "lead",
          fromLinkwise: !!(
            this.props.linkwiseCookies &&
            this.props.linkwiseCookies.fromLinkwise
          ),
          affiliate:
            (this.props.linkwiseCookies &&
              this.props.linkwiseCookies.affiliate) ||
            "",
          googleClientId: fetchGoogleClientId()
        },
        this.props.auth
      );
    } catch (e) {
      return e.response;
    }
    return response;
  }

  sendEmail = (email, offerCode, offerId) => {
    if (!email || !offerCode || !offerId) {
      return;
    }
    sendEmail(
      "completeLead",
      email || "",
      {
        OfferId: offerId || "",
        OfferCode: offerCode || ""
      },
      this.props.auth || ""
    ).catch();
  };

  onQuoteFormDataChange = ({ formData }) => {
    if (formData.currentSupplier === "") {
      formData.currentProduct = "";
    }
    this.props.updateCorporateQuoteFormData(formData);
  };

  componentDidMount() {
    this.setState({ initializeOptins: false });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.formData.currentSupplier !== this.props.formData.currentSupplier
    ) {
      const schema = updateSchemaWithCurrentProduct(
        this.props.formData.currentSupplier,
        this.props.data.products.edges,
        this.state.schema,
        this.props.formData.invoiceType
      );
      this.setState({ schema });
    }

    if (prevProps.formData.invoiceType !== this.props.formData.invoiceType) {
      let schema = updateSchemaWithCurrentSupplier(
        this.props.data.products.edges,
        mergeSchema(this.props.data.formContext.jsonSchema.fields),
        this.props.formData.invoiceType
      );
      schema = updateSchemaWithCurrentProduct(
        this.props.formData.currentSupplier,
        this.props.data.products.edges,
        schema,
        this.props.formData.invoiceType
      );
      this.setState({ schema });
      this.props.updateCorporateQuoteFormData(
        corporateCalculateConsumptionValues(this.props.formData)
      );
    }

    if (
      prevProps.formData.levelOfConsumption !==
      this.props.formData.levelOfConsumption
    ) {
      this.props.updateCorporateQuoteFormData(
        corporateCalculateConsumptionValues(this.props.formData)
      );
    }
  }
}

const mapStateToProps = ({ corporateQuoteData, auth, linkwiseCookies }) => ({
  formData: corporateQuoteData,
  auth,
  linkwiseCookies
});

const mapDispatchToProps = dispatch => ({
  updateCorporateQuoteFormData: formData =>
    dispatch(updateCorporateQuoteFormData(formData)),
  setCorporateOfferCode: offerCode =>
    dispatch(updateCorporateOfferCode(offerCode)),
  updateCorporateOfferId: offerId => dispatch(updateCorporateOfferId(offerId))
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);

export const pageQuery = graphql`
  query quoteCorporateFormPageQuery {
    formContext: strapiComponents(name: { eq: "corporateForm" }) {
      jsonSchema {
        pageTitle
        canonical
        mailingSource
        mailingLists
        mainPageTitle
        mainPageDescription
        fields {
          dayConsumption {
            helpExampleImageUrl
            helpExampleImageUrlDaily
            helpText
            helpTitle
            label
            labelNight
            helpTitleNight
            helpTextKnownConsumptionNight
            helpTextKnownConsumption
            labelMonthly
            helpTextKnownConsumptionMonthly
            helpTitleMonthly
            helpExampleImageUrlMonthly            
            errorMessages {
              required
              minimum
            }
            minimum
          }
          capacityCharge {
            helpExampleImageUrl
            helpTextKnownConsumption
            helpText
            helpTitle
            label
            errorMessages {
              required
              minimum
            }
            minimum
          }
          invoiceType {
            enum
            enumNames
            helpExampleImageUrl
            helpExampleImageUrlG22
            helpExampleImageUrlG23
            helpText
            helpTitle
            label
          }
          knowledgeOfConsumption {
            enum
            enumNames
            helpExampleImageUrl
            helpText
            helpTitle
            helpTextForLead
            label
          }
          levelOfConsumption {
            enum
            enumNames
            helpExampleImageUrl
            helpText
            helpTitle
            label
            errorMessages {
              required
            }
          }
          nightConsumption {
            helpExampleImageUrlNight
            helpText
            helpTitle
            label
            helpTextKnownConsumptionNight
            errorMessages {
              required
              minimum
            }
            minimum
          }
          postalCode {
            enum
            enumNames
            helpExampleImageUrl
            helpText
            helpTitle
            label
            errorMessages {
              required
            }
            searchable
            searchableNoOptionFoundMessage
          }
          standingOrder {
            enum
            enumNames
            helpExampleImageUrl
            helpText
            helpTitle
            label
          }
          currentSupplier {
            helpText
            helpTitle
            label
            searchable
            searchableNoOptionFoundMessage
          }
          currentProduct {
            helpText
            helpTitle
            label
            searchable
            searchableNoOptionFoundMessage
            errorMessages {
              required
              enum
            }
          }
          corporateName {
            helpText
            helpTitle
            label
            placeholder
            errorMessages {
              required
            }
          }
          customerFirstName {
            helpText
            helpTitle
            label
            placeholder
            errorMessages {
              required
            }
          }
          customerLastName {
            helpText
            helpTitle
            label
            placeholder
            errorMessages {
              required
            }
          }
          customerMobilePhoneNumber {
            helpText
            helpTitle
            label
            placeholder
            errorMessages {
              required
              pattern
              maxLength
            }
          }
          termsAndPoliciesAgreement {
            helpText
            helpTitle
            label
            errorMessages {
              required
              enum
            }
          }
        }
        formDisclaimer
        formSubmitButtonText
        formTitle
        formTitleImage
      }
    }

    products: allStrapiProducts(
      filter: {
        productsubcategory: { CustomerType: { eq: "corporate" } }
        State: { nin: ["Published_Internal", "Draft"] }
        company: { id: { ne: null } }
      }
    ) {
      edges {
        node {
          Name
          strapiId
          productsubcategory {
            Name
            id
            CustomerType
            SystemName
          }
          company {
            id
            Name
          }
        }
      }
    }
        defaultFieldContext: strapiComponents(name: {eq: "defaultFieldDefinitions"}) {
    jsonSchema {
      email {
        helpExampleImageUrl
        helpText
        helpTitle
        label
        searchable
        searchableNoOptionFoundMessage
        errorMessages {
          format
          required
        }
        gdprOptIns {
          label
          mailingListId
        }
      }
      subscription {
            label
            helpText
            helpAdditionalText
            helpButtonText
          }
    }
  }
  }
`;
